module.exports = __webpack_public_path__ + "static/img/materials5.ca8ab92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials5.jpg
// module id = 3H63
// module chunks = 1